<template>
    <collapse>
        <collapse-item>
          <template slot="title">
            <div class="collapse-item-header" style="width: 100%">
              Project: {{ ptracProject.name }}
            </div>
          </template>
          <div>
            <span>Type:&nbsp; {{ ptracProject.projectType }}</span>
            <br>
            <span>Departments:&nbsp; <span v-for="department in departments">{{ department.label }} </span></span>

            <br>
            <span>Address:&nbsp; {{ ptracProject.address.streetNumber }} {{ ptracProject.address.streetName }}, {{ ptracProject.address.city }} {{ ptracProject.address.state }}, {{ ptracProject.address.zip }}</span>
            <br>
            <span>Whatever other project data - maybe a link to the project page?</span>
          </div>
        </collapse-item>
      </collapse>
</template>

<script>
import {Collapse, CollapseItem} from 'element-ui'
import {mapGetters} from 'vuex'

export default {
    props: ['ptracProject'],
    components: {
      Collapse,
      CollapseItem,
    },
    computed: {
      ...mapGetters({
      sortedDepartments: 'departments/kvpsForSelectNoIt',
      }),

      departments() {
        let departments= []
        for (const department of this.ptracProject.departments) {
          departments = this.sortedDepartments.filter(each => {return each.value === department})
        }
        return departments
      }
    }
}
</script>
